import { MENU_CLICK } from "./sideBarTypes"

const toggleMenu = () => {
    return{
        type: MENU_CLICK,
    }
}

export default toggleMenu;
